import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const FIELDS = [
  ["name", "Publication Name"], ["tagline", "Tagline"], ["slug", "Public URL Slug"],
  ["logo_url", "Logo URL"], ["favicon_url", "Favicon URL"],
  ["primary_color", "Primary Brand Color"], ["secondary_color", "Secondary Brand Color"],
  ["website_url", "Website URL"], ["contact_email", "Contact Email"],
  ["facebook_url", "Facebook URL"], ["instagram_url", "Instagram URL"], ["x_url", "X URL"],
  ["youtube_url", "YouTube URL"], ["tiktok_url", "TikTok URL"],
];

export default function MagSettings() {
  const [pub, setPub] = useState(null);
  const [stations, setStations] = useState([]);
  useEffect(() => {
    api.get("/mag/publication").then((r) => setPub(r.data));
    api.get("/stations").then((r) => setStations(r.data.stations || r.data || [])).catch(() => {});
  }, []);
  if (!pub) return <div className="p-8 text-sm text-ink-muted">Loading…</div>;

  const save = async () => {
    try {
      const body = Object.fromEntries(FIELDS.map(([k]) => [k, pub[k] ?? ""]));
      body.about = pub.about || "";
      body.radio_station_id = pub.radio_station_id || "";
      await api.put("/mag/settings", body);
      toast.success("Settings saved");
    } catch (e) { toast.error(e?.response?.data?.detail || "Save failed"); }
  };

  return (
    <div className="space-y-4 max-w-2xl" data-testid="mag-settings">
      <h1 className="font-display text-2xl font-bold">Magazine Settings</h1>
      <div className="rounded-xl border border-line bg-bg-surface p-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
        {FIELDS.map(([k, label]) => (
          <div key={k}>
            <div className="text-[10px] font-mono uppercase tracking-wider text-ink-muted mb-1">{label}</div>
            <div className="flex gap-2 items-center">
              {k.endsWith("color") && <input type="color" value={pub[k] || "#E05C3A"} onChange={(e) => setPub((p) => ({ ...p, [k]: e.target.value }))} className="h-8 w-10 rounded border border-line bg-transparent" />}
              <input value={pub[k] || ""} onChange={(e) => setPub((p) => ({ ...p, [k]: e.target.value }))} data-testid={`mag-set-${k}`}
                className="w-full rounded-md border border-line bg-bg-elevated px-2.5 py-1.5 text-sm" />
            </div>
          </div>
        ))}
        <div className="sm:col-span-2">
          <div className="text-[10px] font-mono uppercase tracking-wider text-ink-muted mb-1">About Magazine</div>
          <textarea value={pub.about || ""} onChange={(e) => setPub((p) => ({ ...p, about: e.target.value }))} rows={3} data-testid="mag-set-about"
            className="w-full rounded-md border border-line bg-bg-elevated px-2.5 py-1.5 text-sm" />
        </div>
        <div className="sm:col-span-2">
          <div className="text-[10px] font-mono uppercase tracking-wider text-ink-muted mb-1">Radio Player Station</div>
          <select value={pub.radio_station_id || ""} onChange={(e) => setPub((p) => ({ ...p, radio_station_id: e.target.value }))} data-testid="mag-set-station"
            className="w-full rounded-md border border-line bg-bg-elevated px-2.5 py-1.5 text-sm">
            {(Array.isArray(stations) ? stations : []).map((s) => <option key={s.station_id} value={s.station_id}>{s.name}</option>)}
            {!stations.length && <option value={pub.radio_station_id}>{pub.radio_station_id}</option>}
          </select>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <button onClick={save} data-testid="mag-settings-save" className="rounded-full bg-brand-amber text-black px-5 py-2 text-sm font-bold">Save Settings</button>
        <a href={`/mag/${pub.slug}`} target="_blank" rel="noreferrer" className="text-sm text-brand-cyan underline" data-testid="mag-settings-view-link">View public magazine →</a>
      </div>
    </div>
  );
}
